import React, { useEffect, useState } from "react";
import logoColor from "../assets/images/logos/logo.png";
// import logoWhite from "../assets/images/logos/logo-white.png";
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import "./Header.css";

const APP_URL = process.env.REACT_APP_APP_URL || "https://app.zifit.io";
// 1) Añade el nombre del icono a cada item
const NAV_ITEMS = [
    { id: "home",      label: "Inicio",    icon: "home" },
    { id: "features",  label: "Servicios", icon: "view_quilt" },
    { id: "pricing",   label: "Precios",   icon: "sell" },
    { id: "contact",   label: "Contacto",  icon: "call" },
  ];

  
export default function Header() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 25);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`main-header header ${
        scrolled ? "scrolled" : "transparent"
      }`}
    >
      <div className="container">
        <div className="header-bar d-flex align-items-center justify-content-between py-20">
          {/* Bloque izquierdo: logo + navegación */}
          <div className="left-block d-flex align-items-center">
            <a href="/" className="logo d-flex align-items-center">
                <img src={logoColor} alt="Zifit logo" className="site-logo" />
            </a>

            <nav className="nav-wrapper d-none d-lg-flex ms-5">
            <ul className="nav-list">
                {NAV_ITEMS.map(({ id, label, icon }) => (
                    <li key={id}>
                    <a href={`#${id}`} className="d-flex align-items-center gap-1">
                        <span className="material-symbols-outlined">{icon}</span>
                        <span className="nav-text">{label}</span>
                    </a>
                    </li>
                ))}
                </ul>

            </nav>
          </div>

          {/* Bloque derecho: CTA desktop */}
          <div className="d-none d-xl-inline-flex align-items-center">
            {/* Botón azul “Accede” con icono */}
            <a href={APP_URL} className="theme-btn style-five d-inline-flex align-items-center">
                <span className="material-symbols-outlined">space_dashboard</span>
                <span>Login</span>
            </a>

            {/* Botón amarillo “Empieza Gratis” con el mismo estilo que el de MainSection */}
            <a href={`${APP_URL}`} className="theme-btn style-five btn-start ms-3 d-inline-flex">
                Empieza&nbsp;Gratis
            </a>
            </div>

          {/* Burger móvil */}
          <button
            className="navbar-toggle d-lg-none ms-auto"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#mobile-menu"
            aria-controls="mobile-menu"
            aria-expanded="false"
            aria-label="Toggle navigation"
            >
            <span className="icon-bar" />
            <span className="icon-bar" />
            <span className="icon-bar" />
          </button>
        </div>

        {/* Menú móvil */}
        <div id="mobile-menu" className="collapse d-lg-none">
        <ul className="nav-mobile list-unstyled mb-0 py-3">
            {NAV_ITEMS.map(({ id, label, icon }) => (
            <li key={id} className="py-2 text-center">
                <a href={`#${id}`} className="d-flex align-items-center justify-content-center gap-2">
                <span className="material-symbols-outlined">{icon}</span>
                <span className="nav-text">{label}</span>
                </a>
            </li>
            ))}
        </ul>
        </div>
      </div>
    </header>
  );
}
